/* eslint-disable no-console */
import { readCCPACookie, writeCCPACookie } from "@/common/functions";

const mutations = {
    UPDATE_LIKED_WORDS: (state, actions) => {
        if (!state.user.actions) {
            state.user.actions = {
                upvoted_related_words: [],
                downvoted_related_words: []
            };
        }
        let upvotes = state.user.actions.upvoted_related_words || [];
        let downvotes = state.user.actions.downvoted_related_words || [];
        switch (actions.action) {
            case "upvote":
                upvotes.push(actions.relationIds[0]);
                break;
            case "downvote":
                downvotes.push(actions.relationIds[0]);
                break;
            case "removeUpvote":
                upvotes = upvotes.filter(id => id != actions.relationIds[0]);
                break;
            case "removeDownvote":
                downvotes = downvotes.filter(id => id != actions.relationIds[0]);
                break;
            case "changeUpvoteToDownvote":
                upvotes = upvotes.filter(id => id != actions.relationIds[0]);
                downvotes.push(actions.relationIds[0]);
                break;
            case "changeDownvoteToUpvote":
                downvotes = downvotes.filter(id => id != actions.relationIds[0]);
                upvotes.push(actions.relationIds[0]);
                break;
        }
        state.user.actions.upvoted_related_words = upvotes;
        state.user.actions.downvoted_related_words = downvotes;
        localStorage.setItem("actions", JSON.stringify(state.user.actions));
    },
    SET_LOGGED_IN: (state, value) => {
        state.user.loggedIn = value;
    },
    UPDATE_USER: (state, data) => {
        state.user.data = data;
    },
    SET_USER_ID_TOKEN: (state, token) => {
        state.user.data.idToken = token;
    },
    UPDATE_USPRIVACY: (state, value) => {
        if (!/^[1][nNyY-][nNyY-][nNyY-]$/.test(value)) return;
        state.user.usprivacy = value;

        // Sync the new value to the 'usprivacy' cookie that is read from the "__uspapi()"
        console.log(`LLR-DEBUG> usprivacy: claim=${value} cookie=${readCCPACookie()}`);
        if (value != readCCPACookie()) {
            writeCCPACookie(value);
            console.log(`LLR-DEBUG> Updated cookie: ${readCCPACookie()}`);
        }
    },
    DISPLAY_SAVE_WORD_POPUP: (state, visible) => {
        state.saveWordPopup.visible = visible;
    },
    SET_USER_ACTIONS: (state, actions) => {
        actions
            ? localStorage.setItem("actions", JSON.stringify(actions))
            : localStorage.removeItem("actions");
        state.user.actions = actions;
    },
    UPDATE_STARRED_WORDS: (state, item) => {
        const { actions } = state.user;
        if (item.action === "unStar") {
            state.user.actions["starred_related_words"] = actions["starred_related_words"].filter(
                id => {
                    return !item.relationIds.includes(id);
                }
            );
            localStorage.setItem("actions", JSON.stringify(state.user.actions));
        } else {
            state.user.actions["starred_related_words"] = actions["starred_related_words"].concat(
                item.relationIds
            );
            localStorage.setItem("actions", JSON.stringify(state.user.actions));
        }
    }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/Login/mutations.js